<script>
    export default {
        name: "login-footer-icons",
        props: {
            url: {
                type: String,
                required: true
            }
        }
    }
</script>

<template>
        <div class="my-8 login-footer-icons animate-slide-from-below">
            <a :href="url">
                <img src="/img/Design.svg" alt="design" />
            </a>
            <a :href="url">
                <img src="/img/Plan.svg" alt="plan" />
            </a>
            <a :href="url">
                <img src="/img/Distribute.svg" alt="distribute" />
            </a>
            <a :href="url">
                <img src="/img/Manage.svg" alt="manage" />
            </a>
        </div>
</template>

<style scoped>
    .login-footer-icons {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        max-width: 600px;

        img {
            height: 120px;
        }
    }

    @keyframes slideFromBelow {
        0% {
            transform: translateY(50%);
            opacity: 0;
        }
        100% {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .animate-slide-from-below {
        animation: slideFromBelow 1s ease-out forwards;
    }
</style>
